import { COLORS } from 'helpers/globals'

export default {
  container: {
    borderTop: `1px solid ${COLORS.quaternary}`
  },
  previewImage: {
    display: 'inline-block',
    width: '33%',
    height: 160,
    '& img': {
      height: '100%',
      width: '100%'
    },
    '&:first-of-type': {
      topBar: {
        borderLeft: `1px solid ${COLORS.quaternary}`
      }
    },
    '&:last-of-type': {
      topBar: {
        borderRight: `1px solid ${COLORS.quaternary}`
      }
    }
  },
  topBar: {
    minHeight: '1.6em',
    paddingLeft: '.2rem',
    width: '100%',
    backgroundColor: COLORS.initial,
    color: 'black'
  },
  controllsContainer: {
    backgroundColor: 'white',
    display: 'inline-block',
    verticalAlign: 'top',
    height: 160,
    width: '34%'
  }
}

export const mobileStyle = {
  mobilePreview: {
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      flex: '1 1 50%'
    }
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    background: COLORS.secondary,
    color: 'white',
    fontWeight: 400,
    textAlign: 'center',
    padding: '1rem'
  },
  imageContainer: {
    display: 'flex',
    height: 'calc(50vw * 8 / 7)',
    '& img': {
      flex: '1 1 50%'
    }
  },
  infoContainer: {
    padding: '1rem',
    background: COLORS.secondary,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    '& span': {
      fontWeight: 400,
      textAlign: 'center'
    }
  },
  backButton: {
    flex: 1,
    fontSize: '1.4rem',
    display: 'flex',
    alignItems: 'center'
  },
  backIcon: {
    fontSize: '1.2rem',
    marginRight: '.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/PpfPreview/style.js